import * as React from "react";
import AnnotationGeometry from "./AnnotationGeometry";
import { useAnnotationActions } from "context/";

const AnnotationLineString = ({ annotation }) => {
  const { addLineString } = useAnnotationActions();

  return <AnnotationGeometry
    annotation={annotation}
    addGeometry={addLineString}
  />;
};

export default AnnotationLineString;
